import React from 'react';
import Chip from '@mui/material/Chip';
import InputLabel from '@mui/material/InputLabel';
import Stack from '@mui/material/Stack';
import RobotTag from 'models/robots/robot-tag';
import TooltipIconButton from '@common/components/Inputs/TooltipIconButton';
import { EditIcon } from '@common/utils/icons/icons';
import { useTranslation } from 'react-i18next';

const TagsRow: React.FC<{ label: string; tags: RobotTag[]; onEdit: () => void }> = ({
  label,
  tags,
  onEdit,
}) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Stack direction="row" spacing={2} width="100%" alignItems="center">
        <Stack spacing={1} flexGrow={1}>
          <InputLabel>{label}</InputLabel>
          <Stack direction="row" spacing={2}>
            {tags.length === 0 ? '-' : tags.map((tag) => <Chip key={tag.id} label={tag.tag} />)}
          </Stack>
        </Stack>
        <TooltipIconButton
          tooltip={t('button-edit')}
          color="success"
          icon={<EditIcon />}
          onClick={onEdit}
        />
      </Stack>
    </React.Fragment>
  );
};

export default TagsRow;
